export class CookieSettings {
    public static get() {
        const cookieSettings = {
            path: '/',
            domain: undefined as string | undefined,
            expires: 365, //days
            samesite: 'lax'
        };

        if (
            location.hostname !== 'localhost' &&
            location.hostname.indexOf('192.168') !== 0
        ) {
            (cookieSettings as any).secure = true;
            cookieSettings.domain = location.hostname.replace('www', '');
        }
        return cookieSettings;
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/CookieSettings.ts